import pages from "../../Pages.json";
import IQACDynamicPage from '../../DynamicPage/IQACDynamicPage';
import TableComponent from '../../../components/Table/TableComponent';
import "./DisciplineCommittee.scss";

const DisciplineCommittee = () => {

    const disciplineCommittee = pages['discipline-committee'][0];
    const columns = ["S.No.", "Name", "Designation & Department", "Position", "Email ID"];
    const rows = [
        { name: "Dr. R. Marimuthu", designation: "Principal", membership: "Chairman ", email: "nicollege2001@yahoo.co.in" },
        { name: "Mr. J. Jayaraj", designation: "Physical Director", membership: "Convener", email: "jayansheeja2011@gmil.com" },
        { name: "Dr. S. Kala", designation: "Asst. Prof., Department of  Computer Application", membership: "Co-Convenor", email: "kalajk1980@gmail.com" },
        { name: "Dr. S. Padma Devi", designation: "Asst. Prof. & Head, Department of  Tamil ", membership: "Member", email: "padma101978@gmail.com" },
        { name: "Dr. N. Siva Kumar", designation: "Asst. Prof. & Department of  Tamil", membership: "Member", email: "nadasivakumar@gamil.com" },
        { name: "Mr. K. Krishna Prasad", designation: "Asst. Prof., Department of  Computer Science(PG)", membership: "Member", email: "vskpnair@gmail.com" },
        { name: "Dr. J. Babu Dhas", designation: "Asst. Prof. & Head, Department of Commerce (UG)", membership: "Member", email: "babudhasj31@gmail.com" },
        { name: "Dr. C. Murugesan", designation: "Asst. Prof. & Head, Department of Mathematics (UG)", membership: "Member", email: "kumarithozhanmurugesan@gmail.com" },

    ];

    return (
        <section className="disciplineCommitteeMainContainer">
            <article className="firstSection">
                <IQACDynamicPage
                    title={disciplineCommittee.title}
                    content={disciplineCommittee.content}
                    secondtitle={disciplineCommittee.secondtitle}
                />

                <article className='points-style'>
                    <ol className='points-ol-list-1'>
                        <li> All the students should wear uniforms compulsorily. Students without uniforms will not be allowed to attend classes.</li>
                        <li>Students should wear Identity Cards inside the Campus. </li>
                        <li>Proper respect should be given to Faculty members inside/outside the classrooms.</li>
                        <li>Students should not loiter inside the Campus of the College during working hours. Even if they have no classes, loitering should be avoided.</li>
                        <li>No student shall leave the class without the permission of the teacher. Students attending Lecture, working in Laboratories or attending meetings shall maintain perfect silence.</li>
                        <li>Students should enter their respective classes at the stroke of the first bell before each session.</li>
                        <li>Usage of Mobile phones inside the Campus is strictly prohibited.</li>
                        <li>Movement of students from classrooms to labs and vice versa should be neat and quiet.</li>
                        <li>Damaging College properties is a crime which will be dealt with seriously.</li>
                        <li>Students should intimate the present Residential address. If there are any changes, it should be updated immediately.</li>
                        <li>Disobedience or disrespect to the members of the staff, irregularity in Attendance and in submitting Assignments, violation of Disciplinary rules etc., are strong reasons warranting severe punishment such as suspension or even termination.</li>
                    </ol>

                </article>

                <article className='points-style'>
                    <h2>Discipline</h2>
                    <ol className='points-ol-list-2'>
                        <li>Students should be neatly and decently dressed and should attend the college regularly.</li>
                        <li>Every student is required to observe disciplined and decorous behavior both inside and outside the College.</li>
                        <li>Students should be punctual to the classes. Adherence of rules should be strictly followed inside the classrooms and laboratories.</li>
                        <li>Students reporting late for the class shall enter the class only with the permission of the concerned staff.</li>
                        <li>Students shall take all Internal Assessment tests and Model examinations seriously and should attend the tests without fail.</li>
                        <li>Collection of funds by students is prohibited. Prior permission is needed in case of necessity.</li>
                        <li>Smoking and chewing are strictly prohibited inside the Campus.</li>
                        <li>Only with the written permission of the Principal, the students can organize any function.</li>
                        <li>Students are completely prohibited from participating in any political / communal activities.</li>
                        <li>Eve-teasing inside and outside the College Campus is a punishable crime</li>
                    </ol>
                </article>


            </article>
            <article className="secondSection">
                <h2 style={{ color: "#116C4A" }}>Discipline Committee Member</h2>
                <TableComponent columns={columns} data={rows} />
            </article>
        </section>
    )
}

export default DisciplineCommittee
